const DoctorListPageStyles = () => {
  return {
    topBar: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      justifyContent: "space-between",
      mb: 2,
      p: 2,
      border: "1px solid",
      borderColor: "divider",
      borderRadius: "12px",
      backgroundColor: "background.paper",
      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
    },
    topBarLeft: { display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1.5 },
    errorAlert: { marginBottom: '24px' },
    totalDoctorBox: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minWidth: 100,
    },
    totalDoctorLabel: {
      fontSize: "12px",
      color: "text.secondary",
      fontWeight: 600,
      textTransform: "uppercase",
      letterSpacing: ".5px",
    },
    totaldoctorValue: {
      fontSize: "18px",
      fontWeight: 700,
      color: "primary.main",
      lineHeight: 1.1,
    },
    filtersButton: {
      display: "flex",
      alignItems: "center",
      gap: 1,
      px: 2,
      py: 1,
      borderRadius: "10px",
      bgcolor: "primary.main",
      color: "white",
      cursor: "pointer",
      transition: ".2s",
      "&:hover": { opacity: 0.9 },
    },
    filter: {
      display: "flex",
      alignItems: "center",
      gap: 1,
      px: 2,
      py: 1,
      borderRadius: "10px",
      bgcolor: "background.default",
      border: "1px solid",
      borderColor: "divider",
      boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    },
    deletefilterIcon: {
      cursor: "pointer",
      fontSize: 18,
      color: "text.secondary",
      "&:hover": { color: "error.main" },
    },
    topBarRight: { display: "flex", alignItems: "center", gap: 1 },
    navLink: { textDecoration: "none" },
    newDoctorButton: {
      display: "flex",
      alignItems: "center",
      gap: 1,
      px: 2,
      py: 1,
      borderRadius: "10px",
      bgcolor: "primary.main",
      color: "white",
      cursor: "pointer",
      transition: ".2s",
      "&:hover": { opacity: 0.9 },
    },
    patientsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(600px, 1fr))',
      gap: '0 16px',
      '@media (max-width: 768px)': {
        gridTemplateColumns: '1fr',
      },
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '80px 0',
    },
    emptyState: {
      textAlign: 'center',
      padding: '80px 24px',
      backgroundColor: 'white',
      borderRadius: '12px',
      border: '1px solid #e5e5e5',
    },
    emptyStateIcon: {
      fontSize: '64px',
      color: '#cbd5e1',
      marginBottom: '16px',
    },
    emptyStateTitle: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#1a1a1a',
      marginBottom: '8px',
    },
    emptyStateText: {
      fontSize: '14px',
      color: '#666',
    },
    paginationContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '15px',
    },
    statsContainer: {
      display: 'flex',
      gap: '16px',
      marginBottom: '24px',
      '@media (max-width: 768px)': {
        flexDirection: 'column',
      },
    },
    statCard: {
      flex: 1,
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '12px',
      border: '1px solid #e5e5e5',
      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    },
    statLabel: {
      fontSize: '12px',
      fontWeight: '500',
      color: '#666',
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
      marginBottom: '8px',
    },
    statValue: {
      fontSize: '24px',
      fontWeight: '700',
      color: '#1a1a1a',
    },
  };
};

export default DoctorListPageStyles;
